import { PIP_IFRAME_NAME } from './constants';
/**
 * Tests whether PIP iframe is present, therefor PIP is active. This
 * check should have no dependencies.
 * @returns
 */
export function hasPIPIframe() {
    return typeof window !== 'undefined' && !!window.frames?.[PIP_IFRAME_NAME];
}
